<h2 class="title" *ngIf="!hideTitle">
  {{ "Login" | locale }}
</h2>
<div class="login-form">
  <nz-form-item>
    <nz-form-label nzFor="userName" nzNoColon>
      {{ "Username" | locale }}
    </nz-form-label>
    <nz-input-group [nzPrefix]="userNameIcon">
      <input
        type="text"
        nz-input
        #userNameControl
        [(ngModel)]="userName"
        [placeholder]="'Username' | locale"
        (change)="userNameChanged()"
        (keydown)="submit($event)"
      />
    </nz-input-group>
    <ng-template #userNameIcon
      ><i nz-icon
        ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 19.834">
          <path
            d="M216.621,480.14h19.655c.487-3.7-.255-5.069-3.546-6.383a16.314,16.314,0,0,0-12.909.145C216.76,475.21,215.977,476.731,216.621,480.14Zm9.826-19.834a4.423,4.423,0,0,0-4.464,4.453,4.442,4.442,0,0,0,8.883-.086A4.422,4.422,0,0,0,226.447,460.306Z"
            transform="translate(-216.412 -460.306)"
          /></svg></i
    ></ng-template>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label nzFor="password" nzNoColon>
      {{ "Password" | locale }}
    </nz-form-label>
    <nz-input-group [nzPrefix]="passwordIcon">
      <input
        type="password"
        nz-input
        [(ngModel)]="password"
        [placeholder]="'Password' | locale"
        (keydown)="submit($event)"
      />
    </nz-input-group>
    <ng-template #passwordIcon
      ><i nz-icon
        ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.5 19.333">
          <path
            d="M233.4,548.39H232.19v-1.611a5.639,5.639,0,0,0-11.278,0v1.611H219.7a.4.4,0,0,0-.4.4v10.069a1.612,1.612,0,0,0,1.611,1.611H232.19a1.613,1.613,0,0,0,1.611-1.611V548.793A.4.4,0,0,0,233.4,548.39Zm-5.641,8.414a.4.4,0,0,1-.4.447h-1.611a.4.4,0,0,1-.4-.447l.254-2.285a1.592,1.592,0,0,1-.659-1.3,1.611,1.611,0,1,1,3.222,0,1.6,1.6,0,0,1-.659,1.3Zm2.016-8.414h-6.445v-1.611a3.222,3.222,0,0,1,6.445,0Z"
            transform="translate(-219.301 -541.14)"
          /></svg></i
    ></ng-template>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label nzFor="companyDB" nzNoColon>
      {{ "Company" | locale }}
    </nz-form-label>
    <nz-select
      [(ngModel)]="companyDB"
      [nzPlaceHolder]="'Select company' | locale"
      (nzOpenChange)="loadCompanies()"
    >
      <nz-option
        *ngFor="let company of companies"
        [nzLabel]="company.companyName + ' (' + company.companyDB + ')'"
        [nzValue]="company.companyDB"
      >
      </nz-option>
    </nz-select>
    <ng-template #companyIcon
      ><i nz-icon
        ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.44 18.311">
          <path
            class="a"
            d="M228.482,625.14l-8.45-1.28a1.338,1.338,0,0,0-1.09.29,1.384,1.384,0,0,0-.47,1.03v16.2a.768.768,0,0,0,.76.77h2.5v-4.04a1.342,1.342,0,0,1,1.35-1.34H225a1.34,1.34,0,0,1,1.34,1.34v4.04h3.27V626.47A1.352,1.352,0,0,0,228.482,625.14Zm-5.79,9.9h-1.15a.58.58,0,1,1,0-1.16h1.15a.58.58,0,1,1,0,1.16Zm0-2.31h-1.15a.575.575,0,1,1,0-1.15h1.15a.575.575,0,1,1,0,1.15Zm0-2.3h-1.15a.58.58,0,1,1,0-1.16h1.15a.58.58,0,1,1,0,1.16Zm0-2.31h-1.15a.575.575,0,1,1,0-1.15h1.15a.575.575,0,1,1,0,1.15Zm3.84,6.92h-1.15a.58.58,0,0,1,0-1.16h1.15a.58.58,0,1,1,0,1.16Zm0-2.31h-1.15a.575.575,0,0,1,0-1.15h1.15a.575.575,0,1,1,0,1.15Zm0-2.3h-1.15a.58.58,0,0,1,0-1.16h1.15a.58.58,0,1,1,0,1.16Zm0-2.31h-1.15a.575.575,0,0,1,0-1.15h1.15a.575.575,0,1,1,0,1.15Z"
            transform="translate(-218.472 -623.839)"
          />
          <path
            class="a"
            d="M235.852,632.03l-5.47-1.14v11.26h5.19a1.349,1.349,0,0,0,1.34-1.35v-7.45A1.339,1.339,0,0,0,235.852,632.03Zm-1.82,7.81h-1.15a.575.575,0,1,1,0-1.15h1.15a.575.575,0,0,1,0,1.15Zm0-2.31h-1.15a.572.572,0,0,1-.58-.57.58.58,0,0,1,.58-.58h1.15a.572.572,0,0,1,.57.58A.563.563,0,0,1,234.032,637.53Zm0-2.3h-1.15a.58.58,0,0,1-.58-.58.572.572,0,0,1,.58-.57h1.15a.563.563,0,0,1,.57.57A.572.572,0,0,1,234.032,635.23Z"
            transform="translate(-218.472 -623.839)"
          /></svg></i
    ></ng-template>
  </nz-form-item>
  <nz-space style="width: 100%" nzDirection="vertical">
    <nz-space-item>
      <button
        *ngIf="!hideButton"
        nz-button
        class="login-form-button login-form-margin"
        [nzType]="'primary'"
        [nzLoading]="isLoading"
        (click)="submitForm()"
      >
        <i nz-icon>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.47 24.32">
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <rect
                  x="19.63"
                  y="8.73"
                  width="1.5"
                  height="6.85"
                  style="fill: #fff"
                />
                <rect
                  x="22.97"
                  y="7.88"
                  width="1.5"
                  height="8.55"
                  style="fill: #fff"
                />
                <path
                  d="M10.81,3.87a1.51,1.51,0,1,0,1.5,1.52A1.52,1.52,0,0,0,10.81,3.87Z"
                  style="fill: #fff"
                />
                <path
                  d="M14.92,0h-11V3.47h0V8.78L.59,12.14h0L0,12.71V24.32H4.27L8,20.57l0,0L10.56,18a1.51,1.51,0,0,0-2.14-2.14L5.9,18.41V2h9.81V20.55H10.82l-2,2h8.83V0Z"
                  style="fill: #fff"
                />
              </g>
            </g>
          </svg>
        </i>
        {{ "Sign in" | locale }}
      </button>
    </nz-space-item>
    <nz-space-item
      style="text-align: center"
      *ngIf="!hideTitle && displayLandingPageLink"
    >
      <nz-divider [nzText]="'or' | locale"></nz-divider>
    </nz-space-item>
    <nz-space-item *ngIf="!hideTitle && displayLandingPageLink">
      <a nz-button nzType="link" nzBlock="true" (click)="direct('e')">
        {{ "Login via customer/supplier portal" | locale }}
      </a>
    </nz-space-item>
  </nz-space>
</div>

<ng-template #tplContent>
  <p style="color: black;">{{ "Hello" | locale }} {{ userFullName }}</p>
  <p style="color: black;">
    {{
      "It seems that you are logged in from another device, please go back to login page or logout from other devices."
        | locale
    }}
  </p>
</ng-template>
<ng-template #tplFooter>
  <button nz-button (click)="closeLougoutOthers()">
    {{ "Back" | locale }}
  </button>
  <button
    nz-button
    nzType="primary"
    (click)="logoutOthers()"
    [nzLoading]="logoutOthersLoading"
  >
    {{ "Logout Others" | locale }}
  </button>
</ng-template>
